import dayjs from "../../../utils/dayjs";
import {
  daysJsFormat,
  languagesList,
  renderBeneficiary,
  renderStatusLabels,
  renderTypePrestation,
  renderUserGenderShort,
  renderUserName,
} from "../../../utils/constants";
import { Excel } from "antd-table-saveas-excel";
import { Tag } from "antd";
import React from "react";
import { renderPrestationMajoreeTime } from "../../Prestations/PrestationsList/Prestations.list.constants";
import { t } from "i18next";
import { typesPrestation } from "../../../utils/typesPrestation";

export const BillsExportsExcel = async (prestations, showMin = false) => {
  const exportColumns = [
    {
      title: t("BillsExportFile.prestationNumber"),
      dataIndex: "prestationRef",
    },
    {
      title: t("BillsExportFile.billNumber"),
      dataIndex: "bill_number",
    },
    {
      title: t("BillsExportFile.reference"),
      dataIndex: "reference",
    },
    {
      title: t("BillsExportFile.prestationStatus"),
      dataIndex: "status",
    },
    {
      title: t("prestationInputs.category"),
      dataIndex: "category",
    },
    {
      title: t("prestationInputs.domain"),
      dataIndex: "mainCategory",
    },
    {
      title: t("BillsExportFile.interpreter"),
      dataIndex: "interprete",
    },

    {
      title: t("prestationInformations.beneficiaryReference"),
      dataIndex: "beneficiary_ref",
    },
    {
      title: t("prestationInformations.beneficiaryLastName"),
      dataIndex: "beneficiary_first",
    },
    {
      title: t("prestationInformations.beneficiaryFirstName"),
      dataIndex: "beneficiary_last",
    },
    {
      title: t("prestationInformations.beneficiaryDate"),
      dataIndex: "beneficiary_birth",
    },
    {
      title: t("prestationResumeForm.beneficiarysimic"),
      dataIndex: "beneficiary_simic",
    },
    {
      title: t("prestationResumeForm.beneficiaryn"),
      dataIndex: "beneficiary_n",
    },
    {
      title: t("prestationInputs.gender"),
      dataIndex: "beneficiary_genre",
    },
    {
      title: t("prestationInformations.beneficiaryCountry"),
      dataIndex: "beneficiary_country",
    },
    {
      title: t("InterpreteDetail.genre"),
      dataIndex: "interpreteGenre",
    },
    {
      title: t("BillsExportFile.interpreterId"),
      dataIndex: "interpreteId",
    },
    {
      title: t("BillsExportFile.language"),
      dataIndex: "langue",
    },
    {
      title: t("BillsExportFile.totalWithoutVAT"),
      dataIndex: "totalHorsTva",
    },
    {
      title: t("BillsExportFile.prestationCost"),
      dataIndex: "coutPrestation",
    },
    {
      title: t("BillsExportFile.prestationTranches"),
      dataIndex: "tranchesPrestation",
    },
    {
      title: t("BillsExportFile.nightPrestationTranches"),
      dataIndex: "tranchesPrestationNight",
    },
    {
      title: t("BillsExportFile.nightPrestationCost"),
      dataIndex: "coutNight",
    },
    {
      title: t("BillsExportFile.travelCost"),
      dataIndex: "coutTravel",
    },
    {
      title: t("BillsExportFile.kms"),
      dataIndex: "kms",
    },
    {
      title: t("BillsExportFile.travelCostCff"),
      dataIndex: "amountBillet",
    },
    {
      title: t("BillsExportFile.cffError"),
      dataIndex: "cffError",
    },
    {
      title: t("BillsExportFile.mealCost"),
      dataIndex: "mealCost",
    },
    {
      title: t("BillsExportFile.totalWithVAT"),
      dataIndex: "totalTTC",
    },
    {
      title: t("BillsExportFile.vat"),
      dataIndex: "tvaAmount",
    },
    {
      title: t("BillsExportFile.centsCorrection"),
      dataIndex: "ctsCorrection",
    },
    {
      title: t("BillsExportFile.startDate"),
      dataIndex: "startDate",
    },
    {
      title: t("BillsExportFile.endDate"),
      dataIndex: "endDate",
    },
    {
      title: t("BillsExportFile.startH"),
      dataIndex: "startH",
    },
    {
      title: t("BillsExportFile.endH"),
      dataIndex: "endH",
    },
    {
      title: t("BillsExportFile.departureLocation"),
      dataIndex: "locationFrom",
    },
    {
      title: t("BillsExportFile.interventionLocation"),
      dataIndex: "location",
    },
    {
      title: t("BillsExportFile.prestationType"),
      dataIndex: "typePrestation",
    },
    {
      title: t("BillsExportFile.institution"),
      dataIndex: "institution",
    },
    {
      title: t("BillsExportFile.outOfCanton"),
      dataIndex: "horsCanton",
    },
    {
      title: t("BillsExportFile.urgent"),
      dataIndex: "urgent",
    },
  ];

  const findPresta = (arr, key) => {
    return arr.find(e => e.type === key);
  };

  const mutateData = () => {
    let newArr = [];

    prestations.map(presta => {
      const { bill } = presta;
      let amounts = {
        totalHorsTva: 0,
        totalTTC: 0,
        tvaAmount: 0,
        totalNonAssujeti: 0,
        kms: 0,
        ctsCorrection: 0,
        horsCanton: false,
        urgent: false,
        coutPrestation: 0,
        coutNight: 0,
        coutTravel: 0,
        effectiveTime: "",
      };

      if (bill !== null && bill.costParams !== undefined) {
        const { costParams, costs } = bill;

        amounts.effectiveTime = renderPrestationMajoreeTime(presta, showMin);

        if (bill.type === "multiple") {
          let ref = bill.costsMultiple.find(e => e.prestationId === presta._id);

          if (ref !== undefined) {
            amounts.tvaAmount = costParams.tvaAmount;
            amounts.totalHorsTva = costParams.totalHorsTva;
            amounts.totalTTC = costParams.totalWithTva;

            amounts.totalHorsTva = ref.costParams.total;
            // amounts.kms = metersToKilometers(
            //   ref?.costParams?.driving?.distance?.value || 0,
            // );

            let kms = ref.cost.find(p => p.type === "travel")?.tranches || 0;
            let meal = ref.cost.find(p => p.type === "meal")?.amount || 0;

            amounts.kms = kms;
            amounts.mealCost = meal;

            amounts.horsCanton = ref.costParams.isHorsCanton;
            amounts.urgent = ref.costParams.isUrgent;
            amounts.coutPrestation =
              findPresta(ref.cost, "prestation")?.amount || 0;
            amounts.coutNight = findPresta(ref.cost, "night")?.amount || 0;
            amounts.coutTravel = findPresta(ref.cost, "travel")?.amount || 0;
            amounts.tranchesPrestation =
              findPresta(ref.cost, "prestation")?.tranches || 0;
            amounts.tranchesPrestationNight =
              findPresta(ref.cost, "night")?.tranches || 0;
          }
        } else {
          amounts.totalHorsTva = costParams.total;
          amounts.totalTTC = costParams.totalWithTva;
          amounts.tvaAmount = costParams.tvaAmount;
          // amounts.mealCost = meal;

          // amounts.totalNonAssujeti = costParams.;
          // amounts.kms = metersToKilometers(
          //   costParams?.driving?.distance?.value || 0,
          // );

          let kms = costs.find(e => e.type === "travel")?.tranches || 0;

          amounts.kms = kms;

          amounts.ctsCorrection = costParams.roundCorrection;
          amounts.horsCanton = costParams.isHorsCanton;
          amounts.urgent = costParams.isUrgent;
          amounts.coutPrestation = findPresta(costs, "prestation")?.amount || 0;
          amounts.coutNight = findPresta(costs, "night")?.amount || 0;
          amounts.coutTravel = findPresta(costs, "travel")?.amount || 0;
          amounts.mealCost = findPresta(costs, "meal")?.amount || 0;
          amounts.tranchesPrestation =
            findPresta(costs, "prestation")?.tranches || 0;
          amounts.tranchesPrestationNight =
            findPresta(costs, "night")?.tranches || 0;
        }
      }

      let dates = {
        startDate: null,
        endDate: null,
        startH: null,
        endH: null,
      };

      let locations = {
        location: "",
        locationFrom: "",
      };

      if (
        presta.interventionFinal.startDate !== null &&
        presta.interventionFinal.endDate !== null
      ) {
        dates.startDate = dayjs(presta.interventionFinal.startDate).format(
          daysJsFormat.day,
        );
        dates.endDate = dayjs(presta.interventionFinal.endDate).format(
          daysJsFormat.day,
        );

        dates.startH = dayjs(presta.interventionFinal.startDate).format(
          daysJsFormat.hour,
        );
        dates.endH = dayjs(presta.interventionFinal.endDate).format(
          daysJsFormat.hour,
        );
      } else {
        dates.startDate = dayjs(presta.intervention.startDate).format(
          daysJsFormat.day,
        );
        dates.endDate = dayjs(presta.intervention.endDate).format(
          daysJsFormat.day,
        );

        dates.startH = dayjs(presta.intervention.startDate).format(
          daysJsFormat.hour,
        );
        dates.endH = dayjs(presta.intervention.endDate).format(
          daysJsFormat.hour,
        );
      }

      if (
        presta.interventionFinal.location !== null &&
        presta.interventionFinal.location !== ""
      ) {
        locations.location = presta.interventionFinal.location;
      } else {
        locations.location = presta.intervention.location;
      }

      if (
        presta.interventionFinal.locationFrom !== null &&
        presta.interventionFinal.locationFrom !== ""
      ) {
        locations.locationFrom = presta.interventionFinal.locationFrom;
      } else {
        locations.locationFrom = presta.intervention.locationFrom;
      }

      let status = renderStatusLabels(
        presta.status,
        presta.subStatus,
        presta.isFollow,
      );

      // Extraction des catégories principales et sous-catégories
      const mainArray = [];
      const subArray = presta.category || [];

      subArray
        .filter(e => e !== null)
        .forEach(item => {
          const mainCategory = item.split(".")[1]; // Ici on trouve "formation"

          const parts = item.split(".");

          let labelMain = `${parts[0]}.${mainCategory}.label`;

          if (!mainArray.includes(labelMain)) {
            mainArray.push(labelMain);
          }
        });

      let cff = presta.amountBillet;
      let cffError = undefined;

      try {
        let val = presta?.cff?.error || {};

        const parsed = JSON.parse(val);

        const findErrorText = obj => {
          if (typeof obj !== "object" || obj === null) return null;

          if (obj.hasOwnProperty("ErrorText")) return obj.ErrorText;

          for (const key in obj) {
            const result = findErrorText(obj[key]);
            if (result) return result;
          }

          return null;
        };

        cffError = findErrorText(parsed);
      } catch (e) {
        //console.log(e);
      }

      newArr.push({
        beneficiary_ref: presta.beneficiary?.reference || "",
        beneficiary_first: presta.beneficiary?.firstname || "",
        beneficiary_last: presta.beneficiary?.lastname || "",
        beneficiary_birth: presta.beneficiary?.birthday || "",
        beneficiary_simic: presta.beneficiary?.simic || "",
        beneficiary_n: presta.beneficiary?.n || "",
        beneficiary_genre:
          presta?.beneficiary?.genre === "female"
            ? t("prestationInputs.femaleG")
            : t("prestationInputs.maleG"),
        beneficiary_country: presta.beneficiary?.country || "",
        mainCategory: mainArray.map(e => t(e)).join(", "),
        category: subArray.map(e => t(e)).join(", "),
        interpreteGenre: renderUserGenderShort(presta.interprete),
        langue: presta.languages
          .map(p => languagesList().find(e => e.value === p)?.label)
          .join(" "),
        institution: bill?.institution?.name,
        status: status,
        typePrestation: renderTypePrestation(presta.intervention.type),
        reference: bill?.reference,
        bill_number: bill?.bill_number,
        prestationRef: presta.reference,
        interprete: renderUserName(presta?.interprete),
        interpreteId: presta?.interprete?._id,
        ...amounts,
        ...dates,
        horsCanton: amounts.horsCanton ? "Oui" : "Non",
        urgent: amounts.urgent ? "Oui" : "Non",
        ...locations,
        amountBillet: cff,
        cffError,
      });
    });
    return newArr;
  };

  const excel = new Excel();
  excel
    .addSheet("Facturation")
    .addColumns(exportColumns)
    .addDataSource(mutateData())
    .saveAs("facturation.xlsx");
  return true;
};
